export class AddressesUrlParams {
  static LOGIN: string = "login";  
  static LOGIN_SILENSIOSO: string = "login_silencioso"; 
  static PAGES_HOME: string = "home";
  static PAGES_INICIO: string = "inicio";
  static PAGES_INDEX: string = `index`;


  /**
   * @author Jose Wilson Mulato
   * @description construye la ruta del inicio
   */
  static PathInicio() {
    return `${AddressesUrlParams.PAGES_HOME}/${AddressesUrlParams.PAGES_INICIO}`;
  }

  /**
   * @author Jose Wilson Mulato
   * @description construye la ruta para ir al home
   */
  static PathHome() {
    return `${AddressesUrlParams.PAGES_HOME}/${AddressesUrlParams.PAGES_HOME}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/parameters/addresses-url-params.ts